import type { FunctionComponent } from 'react';
import { getSanityAssetFullUrl, type Env } from '@fff-web/constants';
import ItemImage from './ItemImage';
import * as styles from './styles.module.scss';

const getItems = (shipments: Shipment[]): ProductItem[] =>
  shipments.reduce((result, shipment) => {
    const productItems = shipment.products.reduce(
      (prodItems, product) => [...prodItems, ...product.items],
      [] as ProductItem[],
    );
    return [...result, ...productItems];
  }, [] as ProductItem[]);

type ProductItem = {
  name: string;
  brandName: string;
  imageUrl: string;
  autoAssigned: boolean;
  slug: string;
};

type Shipment = {
  products: {
    items: ProductItem[];
  }[];
};

type MobileItemsProps = {
  shipments: Shipment[];
};

const MobileItems: FunctionComponent<MobileItemsProps> = ({ shipments }) => {
  const items = getItems(shipments);
  return (
    <ul className={styles.mobileItems} data-testid="mobile-items">
      {items.map(({ name, brandName, imageUrl, autoAssigned, slug }, itemIndex) => (
        <ItemImage
          key={itemIndex}
          name={name}
          brandName={brandName}
          imageUrl={getSanityAssetFullUrl(imageUrl, process.env.REACT_APP_ENVIRONMENT as Env)}
          autoAssigned={autoAssigned}
          slug={slug}
        />
      ))}
    </ul>
  );
};

export default MobileItems;
